import { computed } from 'vue';
import store from '@shared/store/index';

/**
 * Computed-свойство: флаг аутентификации пользователя
 * @type {import('vue').ComputedRef<boolean>}
 */
const isAuthenticated = computed(() => store.getters['UserSystem/isAuthenticated']);

/**
 * Computed-свойство: флаг наличия платной подписки
 * @type {import('vue').ComputedRef<boolean>}
 */
const hasPaidAccount = computed(() => store.getters['UserSystem/hasPaidAccess']);

/**
 * Computed-свойство: флаг модераторских прав
 * @type {import('vue').ComputedRef<boolean>}
 */
const isModerator = computed(() => store.getters['UserSystem/hasModeratorPrivileges']);

/**
 * Computed-свойство: флаг загрузки данных пользователя
 * @type {import('vue').ComputedRef<boolean>}
 */
const isLoadingUserData = computed(() => store.getters['UserSystem/hasIsLoading']);

/**
 * Computed-свойство: флаг есть ли упользователя телеграмм аккаунт
 * @type {import('vue').ComputedRef<boolean>}
 */
const isTelegram = computed(() => store.getters['UserSystem/hasTelegramAccount']);

/**
 * Composable-функция для работы с данными аутентификации пользователя
 * @returns {{
 *   isAuthenticated: import('vue').ComputedRef<boolean>,
 *   hasPaidAccount: import('vue').ComputedRef<boolean>,
 *   isModerator: import('vue').ComputedRef<boolean>,
 *   isLoadingUserData: import('vue').ComputedRef<boolean>
 *   isTelegram: import('vue').ComputedRef<boolean>
 * }}
 */
export const useUserAuth = () => ({
  isAuthenticated,
  hasPaidAccount,
  isModerator,
  isLoadingUserData,
  isTelegram
});